import { BerthClosure as ServerBerthClosure, BerthClosureOptions } from 'server/models/BerthClosure';
import { EndMark } from 'data/models/EndMark';
import { PierMark } from 'data/models/PierMark';

export { BerthClosureData, BerthClosureOptions } from 'server/models/BerthClosure';

export class BerthClosure extends ServerBerthClosure {
    // Following aah's note re BerthReservation.EndMark, making PierMark a getter property
    // to avoid needing to recreate it when constructing draft objects.
    get PierMark() { return new PierMark(this.Footmark, this.Berth); }
}



// WEBPACK FOOTER //
// ./data/models/BerthClosure.ts